module.exports = __webpack_public_path__ + "img/warm-FD9E31.0e4cdb2d.png";